import { Button } from '../../../shared/components/Button';
import { DUALITY_MODES, getNextDualityMode } from '../utils/dualityModes';

export function DualityModeButton({ mode = 'standard', onModeChange, disabled = false }) {
  const selectedMode = DUALITY_MODES.find((item) => item.id === mode) || DUALITY_MODES[0];

  return (
    <Button
      label="Duality"
      icon="daggerheart"
      type={selectedMode.buttonType}
      description={selectedMode.description}
      disabled={disabled}
      onPress={() => onModeChange(getNextDualityMode(selectedMode.id))}
    />
  );
}

export function DualityRollButton({ mode = 'standard', onRoll, disabled = false }) {
  const selectedMode = DUALITY_MODES.find((item) => item.id === mode) || DUALITY_MODES[0];

  return (
    <Button
      icon="duality"
      type={selectedMode.buttonType}
      description={selectedMode.rollDescription}
      disabled={disabled}
      onPress={onRoll}
    />
  );
}